require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./scientastic-0-7-3-0.json") })
        }
      }, "path---scientastic-0-7-3-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---scientastic-0-7-3-0!./.cache/json/scientastic-0-7-3-0.json
// module id = 562
// module chunks = 231608221292675